import { CONFIG_FETCHER_ACTIONS } from "../../actions/configFetcherActions";
import { parseResponse } from "../../helpers/helper";
import { USER_TYPE } from '../../constants/common';

const configsDataReducer = (state = {data: null, colorPallete: null, userType: null, colorsUpdated : false, languagesList: null }, action) => {
  switch (action.type) {
    case CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_SUCCESS: {
      return {
        ...state,
        data: parseResponse(action.payload)
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_ERROR: {
      return {
        ...state,
        data: action.payload
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_SUCCESS: {
      return {
        ...state,
        colorPallete: {
          ...state.colorPallete,
          [action.payload.paletteType]: parseResponse(action.payload.data)
        }
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_ERROR: {
      return {
        ...state,
        data: action.payload
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_USER_TYPE_SUCCESS: {
      return {
        ...state,
        userType: action.payload
      };
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_USER_TYPE_ERROR: {
      return {
        ...state,
        userType: USER_TYPE.AMI
      };
    }
    case CONFIG_FETCHER_ACTIONS.COLORS_UPDATED : {
      return{
        ...state,
        colorsUpdated : true
      }
    }
    case CONFIG_FETCHER_ACTIONS.FETCH_LANGUAGE_PREFERENCES : {
      return {
        ...state,
        languagesList: action.payload
      }
    }
    default: return state;
  }
};

export default configsDataReducer;
